import { connect } from 'react-redux'
import { StoreLocatorComponent } from './StoreLocatorComponent'
import type { Coordinates, SearchParams } from 'shared/store/store-locator'
import {
    applyFilters,
    clearSearch,
    fetchStoreLocatorPageData,
    search,
    selectRestaurant,
    setUserPosition
} from 'shared/store/store-locator'
import type { RootState } from 'shared/store/reducers'
import type { Dispatch } from 'redux'
import type { RestaurantShortDTO } from 'shared/types'

const mapStateToProps = (state: RootState) => {
    const {
        address,
        restaurants,
        visitedRestaurants,
        geocodedAddress,
        userPosition
    } = state.storeLocatorPageState

    const hasVisitedRestaurants =
        visitedRestaurants && visitedRestaurants.length > 0

    const hasSearchBeenMade = address !== null

    // Temporary fix to filter out restaurants with statusType 'PRE_OPEN' until we use static store locator data
    const filteredRestaurants = restaurants
        ? restaurants.filter(restaurant => restaurant.statusType !== 'PRE_OPEN')
        : null

    const displayedRestaurants =
        (hasSearchBeenMade ? filteredRestaurants : null) ||
        (hasVisitedRestaurants ? visitedRestaurants : null)

    const resultsTitleKey = hasSearchBeenMade
        ? 'search'
        : hasVisitedRestaurants
        ? 'visited'
        : null

    const shouldDisplayLandingPage =
        !hasSearchBeenMade && !hasVisitedRestaurants

    return {
        ...state.storeLocatorPageState,
        resultsTitleKey,
        restaurants: displayedRestaurants,
        shouldDisplayLandingPage,
        hasSearchBeenMade,
        originForDirections: geocodedAddress || userPosition,
        mainNavigationOpen: state.uiState.mainNavigationOpen
    }
}

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
    fetchPageData: () => dispatch(fetchStoreLocatorPageData()),
    selectRestaurant: (r: RestaurantShortDTO) => dispatch(selectRestaurant(r)),
    searchNearUserPosition: (p: SearchParams) => dispatch(search(p, 'nearest')),
    setUserPosition: (p: Coordinates) => dispatch(setUserPosition(p)),
    applyFilters: f => dispatch(applyFilters(f)),
    clearSearch: () => dispatch(clearSearch())
})

const StoreLocator = connect(
    mapStateToProps,
    mapDispatchToProps
)(StoreLocatorComponent)

export { StoreLocator }
